import React, { useContext } from 'react';
import { map } from 'lodash-es';
import { ListItemText, Typography, useTheme } from '@mui/material';
import InfoCardWrapper from 'components/reviewResultsPage/common/wrappers/infoCardWrapper';
import InfoCardHeader from 'components/reviewResultsPage/common/header/infoCardHeader';
import InfoCardContentWrapper from 'components/reviewResultsPage/common/wrappers/infoCardContentWrapper';
import IconRocket from 'icons/rocket';
import ListWrapper from 'components/reviewResultsPage/common/cardLists/list/listWrapper';
import ListItemWrapper from 'components/reviewResultsPage/common/cardLists/list/listItemWrapper';
import { UiContext } from 'uiContext';
import { observer } from 'mobx-react-lite';
import { MobxContext } from 'mobx/mobxContext';

export default observer(function AchievementsCard() {
  const theme = useTheme();

  const {
    spacings: { sp },
  } = useContext(UiContext);

  const {
    mobxStore: { employeeFormStore },
  } = useContext(MobxContext);

  const { achievements } = employeeFormStore;

  if (!achievements) {
    return null;
  }

  return (
    <InfoCardWrapper>
      <InfoCardHeader
        uppercase
        icon={<IconRocket />}
        mainText="Достижения"
        bgColor={theme.palette.custom.infoCardHeaderColor}
      />

      <InfoCardContentWrapper>
        <ListWrapper>
          {map(achievements, (label, index) => (
            <ListItemWrapper isSidePaddingEnabled key={index} index={index}>
              <ListItemText>
                <Typography
                  variant="f22a"
                  sx={{
                    color: theme.palette.custom.white,
                    marginRight: sp.s10,
                  }}
                >
                  {`${index + 1}.`}
                </Typography>
                <Typography
                  variant="f22a"
                  sx={{ color: theme.palette.custom.white }}
                >
                  {label}
                </Typography>
              </ListItemText>
            </ListItemWrapper>
          ))}
        </ListWrapper>
      </InfoCardContentWrapper>
    </InfoCardWrapper>
  );
});
